import React from 'react';
import { useParams } from 'react-router-dom';
import TicketsBoard from './components/TicketsBoard.jsx';
import DepartmentBoard from './components/DepartmentBoard.jsx';
import CreateTicketModal from './components/CreateTicketModal.jsx';
import TicketDetailModal from './components/TicketDetailModal.jsx';
import '../../../assets/scss/views/ViewTickets.scss';
import { useLayout } from '../../../context/LayoutContext';
import { useTickets } from '../../../context/TicketsContext';

const ViewTickets = () => {
  const { theme } = useLayout();
  const { departmentId } = useParams();
  const { 
    isCreateModalOpen, 
    isDetailModalOpen, 
    setCurrentDepartment 
  } = useTickets();

  React.useEffect(() => {
    if (departmentId) {
      setCurrentDepartment(departmentId);
    }
  }, [departmentId, setCurrentDepartment]);

  return (
    <div className={`GM__${theme}-tickets-container`}>
      {departmentId ? (
        <DepartmentBoard departmentId={departmentId} />
      ) : (
        <TicketsBoard />
      )}

      {isCreateModalOpen && <CreateTicketModal />}
      {isDetailModalOpen && <TicketDetailModal />}
    </div>
  );
};

export default ViewTickets;